export default {
  sessions: {
    // Tasks: Descriptions
    session_0: ['selectCoach'],
    session_1: [],
    session_2: [],
    after_2: ['finalizeLGA'],
    session_3: ['finalizeLGA'],
    after_3: ['finalizeStakeholder'],
    session_4: ['finalizeStakeholder', 'publishAP'],
    after_4: ['publishAP'],
    session_5: ['publishAP'],
    session_6: ['publishAP', 'doPulseSurvey'],
    session_7: ['publishAP'],
    session_8: ['publishAP'],
    session_9: ['publishAP', 'doPulseSurvey'],
    session_10: ['publishAP'],
    session_11: ['publishAP'],
    session_12: ['publishAP', 'doPulseSurvey'],
    session_13: ['publishAP'],
  },

  documents: {
    // REVIEW: TITLE, myJourneyData.js Key
    document_after_2: [
      // {
      //   title: 'REVIEW: Paradigms of Successful People',
      //   key: 'para',
      // },
      // {
      //   title: 'REVIEW: Coworker Onboarding',
      //   key: 'stak',
      // },
      // {
      //   title: 'REVIEW: How Feedforward is Collected',
      //   key: 'feed',
      // },
    ],
    document_3: [
      // {
      //   title: 'REVIEW: Paradigms of Successful People',
      //   key: 'para',
      // },
      // {
      //   title: 'REVIEW: Coworker Onboarding',
      //   key: 'stak',
      // },
      // {
      //   title: 'REVIEW: How Feedforward is Collected',
      //   key: 'feed',
      // },
    ],
    document_after_5: [
      // {
      //   title: 'REVIEW: Pulse Survey Process and Benefits',
      //   key: 'pulseBenefit',
      // },
    ],
    document_6: [
      // {
      //   title: 'REVIEW: Pulse Survey Process and Benefits',
      //   key: 'pulseBenefit',
      // },
    ],
    document_after_8: [
      // {
      //   title: 'REVIEW: Pulse Survey Process and Benefits',
      //   key: 'pulseBenefit',
      // },
    ],
    document_9: [
      // {
      //   title: 'REVIEW: Pulse Survey Process and Benefits',
      //   key: 'pulseBenefit',
      // },
      // // Contents not prepared yet //
      // {
      //   title: 'REVIEW: Preparing for Your Last Session with HR & LM',
      //   key: 'reviewSession',
      // },
    ],
  },
};
